<template>
    <b-form class="formresize" @submit="submitFormHandler" v-if="updateForm">
        <div class="form-group row" v-if="updateForm.id">
            <label class="col-md-2 col-form-label">{{ $t('filter.documentId') }}</label>
            <div class="col-md-10">
                <b-form-input
                    :value="updateForm.id"
                    disabled="disabled">
                </b-form-input>
            </div>
        </div>
        <div class="form-group row">
            <label for="editField-Touroperator" class="col-md-2 col-form-label">{{ $t('filter.touroperator') }}</label>
            <div class="col-md-10">
                <vue-bootstrap-typeahead
                    id="editField-Touroperator"
                    ref="typeahead"
                    @hit="touroperatorData = $event.value"
                    :data="touroperators"
                    :inputClass="autocompleteValidClass"
                    :serializer="item => item.name"
                    v-model="touroperatorData"
                />
            </div>
        </div>
        <div class="form-group row">
            <div class="col-md-2">{{ $t('update.name') }}</div>
            <div class="col-md-10">
                <b-form-input :state="typeof(updateForm.name) !== 'undefined' && updateForm.name !== ''" v-model="updateForm.name">
                </b-form-input>
            </div>
        </div>
        <div class="form-group row">
            <label for="editField-DateFrom" class="col-md-2 col-form-label">{{ $t('filter.validFrom') }}</label>
            <div class="col-md-10">
                <b-form-datepicker
                    v-model="updateForm.valid_from"
                    id="editField-DateFrom"
                    class="mb-2">
                </b-form-datepicker>
            </div>
        </div>
        <div class="form-group row" v-if="updateForm.file">
            <label for="editField-File" class="col-md-2 col-form-label">{{ $t('update.uploadedFile') }}</label>
            <div class="col-md-10">
                <b-input-group>
                    <b-form-input
                        :value="updateForm.file"
                        disabled="disabled">
                    </b-form-input>
                    <template v-slot:append>
                        <a :href="updateForm.file" target="_blank" class="btn btn-secondary"><font-awesome-icon icon="file-download"></font-awesome-icon></a>
                    </template>
                </b-input-group>
            </div>
        </div>
        <div class="form-group row">
            <label for="editField-File" class="col-md-2 col-form-label">{{ $t('update.termsFile') }}</label>
            <div class="col-md-10">
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="editField-FileAddon">{{ $t('update.upload') }}</span>
                    </div>
                    <div class="custom-file">
                        <b-form-file
                            v-model="fileModel"
                            :state="Boolean(fileModel)"
                            :placeholder="$t('update.fileplaceholder')"
                            :drop-placeholder="$t('update.filedropplaceholder')"
                            @change="updateFileHandler"
                        ></b-form-file>
                    </div>
                </div>

            </div>
        </div>
        <div class="form-group row">
            <div class="col-md-2">{{ $t('filter.active') }}</div>
            <div class="col-md-10">
                <b-form-checkbox
                    v-model="updateForm.active"
                    switch
                ></b-form-checkbox>
            </div>
        </div>
        
    </b-form>
</template>
<script>
    import moment from 'moment';
    import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';
    
    export default {
        components: {
            VueBootstrapTypeahead
        },
        data() {
            return {
                updateForm: null,
                fileModel: null,
                touroperatorData: '',
                touroperators: require("@/config/touroperators.json"),
            };
        },
        props: {
            formModel: {
                required: true
            }
        },
        computed: {
            autocompleteValidClass() {
                if (this.touroperatorData !== '') {
                    return 'is-valid';    
                }
                return 'is-invalid';
            }
        },
        methods: {
            updateFileHandler(event) {
                this.$emit('updateFile', event.target.files[0]);
            },
            formatValidFrom() {
                let date = this.updateForm.valid_from;
                if (typeof date === 'string' || date === '' || !date) {
                    return date;
                }
                return moment(date.seconds * 1000).format('YYYY-MM-DD');
            },
            /**
             * enforces modal ok button by disabling internal submit of form
             * 
             * @param {object} e                  the submit event
             * @returns {null}
             */ 
            submitFormHandler(e) {
                e.preventDefault();
                return;
            }
        },
        watch: {
            updateForm: {
                handler: function(nVal, oVal) {
                    if(!oVal) {
                        return;
                    }
                    this.$emit('change', this.updateForm);
                },
                deep: true
            },
            touroperatorData: {
                handler: function(nVal, oVal) {
                    this.updateForm.to_code = nVal;
                    this.$emit('change', this.updateForm);
                }
            }
        },
        mounted() {
            this.updateForm = this.formModel;
            if (this.updateForm.to_code) {
                this.$nextTick(()=> {
                    this.touroperatorData = this.$refs.typeahead.inputValue = this.updateForm.to_code;
                });
            }
            this.updateForm.valid_from = this.formatValidFrom();
        }
    }
</script>
<style scoped lang="scss">
    .formresize {
        min-height: 60vh;
    }
</style>
